import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Slide from '@material-ui/core/Slide';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MenuSettingsDialog from './MenuSettingsDialog';
import MenuPasswordDialog from './MenuPasswordDialog';

const styles = () => ({
  appBar: {
    color: '#fff',
    backgroundColor: '#2096f3',
    boxShadow: 'none',
    borderBottom: '1px solid #eee',
    position: 'relative',
  },
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class MenuDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: props.isOpen,
      hash: '', // HACK

      settingsMenuIsOpen: false,
      settingsMenuHash: '',

      passwordMenuIsOpen: false,
      passwordMenuHash: '',
    };

    this.onClose = this.onClose.bind(this);
    this.onSettingsMenuClick = this.onSettingsMenuClick.bind(this);
    this.onPasswordMenuClick = this.onPasswordMenuClick.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.hash === this.state.hash) {
      return;
    }

    this.setState({
      isOpen: this.props.isOpen,
      hash: this.props.hash,
    });
  }

  onSettingsMenuClick() {
    this.setState({
      settingsMenuIsOpen: true,
      settingsMenuHash: `${(new Date()).getTime()}`, // Hack for the redrawing,
    });
  }

  onPasswordMenuClick() {
    this.setState({
      passwordMenuIsOpen: true,
      passwordMenuHash: `${(new Date()).getTime()}`, // Hack for the redrawing,
    });
  }

  onClose() {
    this.setState({
      isOpen: false,
    });
  }

  render() {
    const {
      classes,
      t,
      onMenuItemClick,
    } = this.props;
    const {
      isOpen,
      settingsMenuIsOpen,
      settingsMenuHash,
      passwordMenuIsOpen,
      passwordMenuHash,
    } = this.state;

    return (
      <div className="menu-dialog">
        <Dialog
          fullScreen
          open={isOpen}
          onClose={this.onClose}
          TransitionComponent={Transition}
          className="menu-dialog"
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={this.onClose}
                aria-label={t('Close')}
                className="menu-dialog-close-button"
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <List>
            {appType === 'parent' && (
              <ListItem
                button
                onClick={onMenuItemClick.bind(this, 'dashboard')}
              >
                <ListItemText primary={t('Dashboard')} />
              </ListItem>
            )}
            {appType === 'parent' && (
              <ListItem
                button
                onClick={this.onSettingsMenuClick}
              >
                <ListItemText primary={t('Account details')} />
              </ListItem>
            )}
            {appType === 'parent' && (
              <ListItem
                button
                onClick={this.onPasswordMenuClick}
              >
                <ListItemText primary={t('Change password')} />
              </ListItem>
            )}
            {appType === 'parent' && <Divider />}
            {appType === 'student' && (
              <ListItem
                button
                onClick={onMenuItemClick.bind(this, 'my_code')}
              >
                <ListItemText primary={t('My code')} />
              </ListItem>
            )}
            <ListItem
              button
              onClick={onMenuItemClick.bind(this, 'logout')}
            >
              <ListItemText primary={t('Logout')} />
            </ListItem>
          </List>
        </Dialog>
        <MenuSettingsDialog
          isOpen={settingsMenuIsOpen}
          hash={settingsMenuHash}
          useSuspense={false}
        />
        <MenuPasswordDialog
          isOpen={passwordMenuIsOpen}
          hash={passwordMenuHash}
          useSuspense={false}
        />
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(MenuDialog));
